import {
  Alert,
  Chip,
  Divider,
  IconButton,
  InputAdornment,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import GapsinBrandData from "./FTDLoadedAccordions/GapsinBrandData";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ConversionLoadingFailures from "./FTDLoadedAccordions/ConversionLoadingFailures";
import MissingPlatformID from "./FTDLoadedAccordions/MissingPlatformID";
import LateConversions from "./FTDLoadedAccordions/LateConversions";
import UnpaidTrafficSource from "./FTDLoadedAccordions/UnpaidTrafficSource";
import AlternativePlatformIdentifiers from "./FTDLoadedAccordions/AlternativePlatformIdentifiers";
import ConversionsUploadComparison from "./FTDLoadedAccordions/ConversionsUploadComparison/ConversionsUploadComparison";
import FtdLoadedPieChart from "./FtdLoadedPieChart";
import MultiSegmentBar from "./ProgressChart";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectIsLoading,
  selectUserToken,
  selectUserWebsitePermissions,
  setIsLoading,
} from "../../../../../../features/userSlice";
import { trackPromise } from "react-promise-tracker";
import { useSearchParams } from "react-router-dom";
import { getAllDataForLoadedFromTotal } from "./helpers/loadedFromTotalHelpers";
import dayjs, { Dayjs } from "dayjs";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FtdLoadedPieChartB from "./FtdLoadedPieChartB";
import store from "../../../../../../store";
import {
  DateRangePicker,
  LocalizationProvider,
  SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import FtdLoadedSkeleton from "./helpers/FtdLoadedSkeleton";
import ConversionsUploadOverTimeGraph from "./ConversionsUploadOverTimeGraph";
import ConversionsUploadBreakdownIncvTraffic from "./FTDLoadedAccordions/ConversionsUploadBreakdownIncvTraffic";

const FtdLoadedFromTotal = () => {
  const isLoading = useSelector(selectIsLoading);
  const authToken = useSelector(selectUserToken)?.toString();

  // getting values from URL
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedActionType = searchParams.get("selectedActionType") as string;
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const isValidStart =
    startDate && dayjs(startDate, "YYYY-MM-DD", true).isValid();
  const isValidEnd = endDate && dayjs(endDate, "YYYY-MM-DD", true).isValid();
  const combinedDateRange =
    isValidStart && isValidEnd ? `${startDate}|${endDate}` : null;
  const selectedSharedUidBuiURL = searchParams.get("selectedSharedUids") as any;
  const selectedSharedUids = selectedSharedUidBuiURL?.split(",") as any;
  const selectedDimensionsURL = searchParams.get("selectedDimension") as string;
  const selectedDimensions = selectedDimensionsURL?.split(",") as any;
  const selectedTypeURL = searchParams.get("selectedType") as string;
  const selectedAllURL = searchParams.get("selectedAll") as string;

  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([
    dayjs(
      searchParams.get("startDate") ||
        dayjs().subtract(7, "days").format("YYYY-MM-DD")
    ),
    dayjs(searchParams.get("endDate") || dayjs().format("YYYY-MM-DD")),
  ]);
  const [pickerRange, setPickerRange] =
    useState<[Dayjs | null, Dayjs | null]>(dateRange);

  // checking if values appeares URL
  const websites = useSelector(selectUserWebsitePermissions) as any;

  //-- Get site name
  const siteLabels = websites
    ?.filter((item: any) => {
      const key = Object.keys(item)[0];
      return selectedSharedUidBuiURL?.split(",")?.includes(key);
    })
    ?.map((value: any) => {
      const key = Object.keys(value)[0];
      return value[key]?.site_name;
    });

  // states for accordions data
  const [loadedFromTotal, setLoadedFromTotal] = useState([]) as any;
  const [gapBrandData, setGapBrandData] = useState([]) as any;
  const [trafficSourceData, setTrafficSourceData] = useState([]) as any;
  const [platformIDdata, setPlatformIDdata] = useState([]) as any;
  const [lateConversionsData, setLateConversionsData] = useState([]) as any;
  const [loadingFailuresData, setLoadingFailuresData] = useState([]) as any;
  const [platformIdentifiersData, setPlatformIdentifiersData] = useState(
    []
  ) as any;
  const [uploadedToPlatformsData, setUploadedToPlatformsData] = useState(
    []
  ) as any;
  const [advertisingPlatformsData, setAdvertisingPlatformsData] = useState(
    []
  ) as any;
  const [incentivizedTrafficData, setIncentivizedTrafficData] = useState(
    []
  ) as any;
  const [rows, setRows] = useState([]) as any;
  const [, setGapcalculated] = useState<number>(0);
  const [dataSegmentsA, setDataSegmentsA] = useState([] as any);
  const [dataSegmentsB, setDataSegmentsB] = useState([] as any);

  const [updatedDataSegmentA, setUpdatedDataSegmentA] = useState([] as any);
  const [updatedDataSegmentB, setUpdatedDataSegmentB] = useState([] as any);

  const allReady =
    Object.keys(gapBrandData)?.length &&
    Object.keys(trafficSourceData)?.length &&
    Object.keys(platformIDdata)?.length &&
    Object.keys(lateConversionsData)?.length &&
    Object.keys(loadingFailuresData)?.length &&
    Object.keys(platformIdentifiersData)?.length &&
    loadedFromTotal?.query_output?.length > 0;

  useEffect(() => {
    if (loadedFromTotal?.query_output?.length >= 0) {
      setRows(loadedFromTotal?.query_output);
    }
  }, [loadedFromTotal]);

  useEffect(() => {
    if (allReady) {
      store.dispatch(setIsLoading(false));
      const totalConversion = Array.isArray(loadedFromTotal?.query_output)
        ? loadedFromTotal?.query_output.reduce((sum: number, r: any) => {
            const v = Number(r?.total_conversion ?? 0);
            return sum + (isFinite(v) ? v : 0);
          }, 0)
        : 0;
      const totalLoaded = Array.isArray(loadedFromTotal?.query_output)
        ? loadedFromTotal?.query_output.reduce((sum: number, r: any) => {
            const v = Number(r?.total_conversion_loaded ?? 0);
            return sum + (isFinite(v) ? v : 0);
          }, 0)
        : 0;

      const brandGap = gapBrandData?.query_output?.reduce(
        (sum: any, item: any) => sum + item.gap,
        0
      );
      const isFTD = selectedActionType?.toLowerCase() === "ftd";

      const trafficSourceLen = trafficSourceData?.query_output?.length ?? 0;
      const platformIdLen = platformIDdata?.query_output?.length ?? 0;
      const loadingFailuresLen = loadingFailuresData?.query_output?.length ?? 0;
      const incentivizedLen =
        incentivizedTrafficData?.query_output?.length ?? 0;
      const gap =
        totalConversion -
        (brandGap +
          trafficSourceLen +
          platformIdLen +
          (isFTD ? incentivizedLen : 0) + // only when FTD
          loadingFailuresLen) -
        totalLoaded;

      setGapcalculated(gap);

      const segmentsA: any[] = [
        {
          label: "Gaps in Brand Data",
          count: brandGap,
          percent: ((brandGap / totalConversion) * 100)?.toFixed(2),
          color: "#6200EE",
        },
        {
          label: "Unpaid Traffic Source",
          count: trafficSourceLen,
          percent: ((trafficSourceLen / totalConversion) * 100)?.toFixed(2),
          color: "#FF928A",
        },
        {
          label: "Missing Platform ID",
          count: platformIdLen,
          percent: ((platformIdLen / totalConversion) * 100)?.toFixed(2),
          color: "#3CC3DF",
        },
        {
          label: "Conversion Loading Failures",
          count: loadingFailuresLen,
          percent: ((loadingFailuresLen / totalConversion) * 100)?.toFixed(2),
          color: "#D7369C",
        },
      ];
      if (isFTD) {
        segmentsA.push({
          label: "Incentivized Traffic",
          count: incentivizedLen,
          percent: ((incentivizedLen / totalConversion) * 100)?.toFixed(2),
          color: "#D7369C",
        });
      }

      segmentsA.push({
        label: "Investigation Required",
        count: gap,
        percent: ((gap / totalConversion) * 100)?.toFixed(2),
        color: "#EF5350",
      });

      setDataSegmentsA(segmentsA);
      setDataSegmentsB([
        {
          label: "Normal Conversions",
          count:
            totalLoaded -
            lateConversionsData?.query_output?.length -
            platformIdentifiersData?.query_output?.length,
          percent: (
            ((totalLoaded -
              lateConversionsData?.query_output?.length -
              platformIdentifiersData?.query_output?.length) /
              totalConversion) *
            100
          )?.toFixed(2),
          color: "#6200EE",
        },
        {
          label: "Late Conversions",
          count: lateConversionsData?.query_output?.length,
          percent: (
            (lateConversionsData?.query_output?.length / totalConversion) *
            100
          )?.toFixed(2),
          color: "#FFAE4C",
        },
        {
          label: "Alternative Platform Identifiers",
          count: platformIdentifiersData?.query_output?.length,
          percent: (
            (platformIdentifiersData?.query_output?.length / totalConversion) *
            100
          )?.toFixed(2),
          color: "#537FF1",
        },
      ]);
    }
    // eslint-disable-next-line
  }, [allReady]);

  const getDataFromTotal = () => {
    if (
      selectedSharedUidBuiURL &&
      selectedDimensionsURL &&
      selectedTypeURL &&
      selectedAllURL &&
      startDate &&
      endDate &&
      selectedActionType
    )
      getAllDataForLoadedFromTotal(
        selectedSharedUids,
        selectedDimensions,
        selectedTypeURL,
        selectedAllURL,
        startDate,
        endDate,
        authToken,
        trackPromise,
        setLoadedFromTotal,
        setGapBrandData,
        setTrafficSourceData,
        setIncentivizedTrafficData,
        setPlatformIDdata,
        setLateConversionsData,
        setLoadingFailuresData,
        setPlatformIdentifiersData,
        setUploadedToPlatformsData,
        setAdvertisingPlatformsData,
        selectedActionType
      );
  };

  const resetStates = () => {
    // reseting states
    setGapBrandData([]);
    setTrafficSourceData([]);
    setPlatformIDdata([]);
    setLateConversionsData([]);
    setLoadingFailuresData([]);
    setPlatformIdentifiersData([]);
    setLoadedFromTotal([]);
    setDataSegmentsA([]);
    setDataSegmentsB([]);
    setUpdatedDataSegmentA([]);
    setUpdatedDataSegmentB([]);
    setUploadedToPlatformsData([]);
    setAdvertisingPlatformsData([]);
    setIncentivizedTrafficData([]);
  };
  const isSingleDayRange = (range: [Dayjs | null, Dayjs | null]) =>
    !!range[0] && !!range[1] && range[0].isSame(range[1], "day");

  const handleDateRangeNavigation = (direction: "prev" | "next") => {
    if (!dateRange[0] || !dateRange[1]) return;
    if (!isSingleDayRange(dateRange)) return;

    const delta = direction === "next" ? 1 : -1;
    const newStart = dateRange[0].add(delta, "day");
    const newEnd = dateRange[1].add(delta, "day");

    const newRange: [Dayjs, Dayjs] = [newStart, newEnd];

    setDateRange(newRange);
    setPickerRange(newRange);

    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set("startDate", newStart.format("YYYY-MM-DD"));
    updatedParams.set("endDate", newEnd.format("YYYY-MM-DD"));
    setSearchParams(updatedParams);
  };

  useEffect(() => {
    resetStates();
    getDataFromTotal();
    // eslint-disable-next-line
  }, [startDate, endDate]);

  useEffect(() => {
    if (
      Object.keys(uploadedToPlatformsData)?.length &&
      Object.keys(advertisingPlatformsData)?.length
    ) {
      store.dispatch(setIsLoading(false));
    }
  }, [uploadedToPlatformsData, advertisingPlatformsData]);

  useEffect(() => {
    if (dataSegmentsA?.length > 0) {
      setUpdatedDataSegmentA(dataSegmentsA);
    }
  }, [dataSegmentsA]);

  useEffect(() => {
    if (dataSegmentsB?.length > 0) {
      setUpdatedDataSegmentB(dataSegmentsB);
    }
  }, [dataSegmentsB]);

  const isSingle =
    !!dateRange[0] &&
    !!dateRange[1] &&
    dateRange[0].isSame(dateRange[1], "day");

  const totalConversionLoaded = Array.isArray(rows)
    ? rows.reduce((sum: number, r: any) => {
        const v = Number(r?.total_conversion_loaded ?? 0);
        return sum + (isFinite(v) ? v : 0);
      }, 0)
    : 0;

  const totalConversion = Array.isArray(rows)
    ? rows.reduce((sum: number, r: any) => {
        const v = Number(r?.total_conversion ?? 0);
        return sum + (isFinite(v) ? v : 0);
      }, 0)
    : 0;
  const aggregatedPercLoaded =
    totalConversion > 0 ? (totalConversionLoaded / totalConversion) * 100 : 0;

  const normalizeRange = (range: [Dayjs | null, Dayjs | null]) => {
    const start = range[0];
    const end = range[1] ?? range[0] ?? null;
    return [start, end] as [Dayjs | null, Dayjs | null];
  };

  return (
    <>
      {isLoading ? (
        <FtdLoadedSkeleton />
      ) : (
        <>
          <Paper sx={{ padding: "8px 16px 16px", mt: 1 }}>
            <>
              <Grid container spacing={4} minHeight={86}>
                <Grid size={12}>
                  <Box>
                    <Stack
                      direction={"row"}
                      gap={2}
                      alignItems={"center"}
                      mb={2}
                    >
                      <Typography variant="h5">
                        % of {selectedActionType?.toLocaleUpperCase()} loaded
                        from total
                      </Typography>
                      {/* date navigator */}
                      <Stack direction={"row"} gap={2} alignItems={"center"}>
                        <Stack
                          direction={"row"}
                          gap={1}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateRangePicker
                              slots={{ field: SingleInputDateRangeField }}
                              name="allowedRange"
                              value={pickerRange}
                              format="DD/MM/YYYY"
                              disabled={isLoading}
                              closeOnSelect={false}
                              onChange={(
                                newValue: [Dayjs | null, Dayjs | null] | null
                              ) => {
                                if (!newValue) return;
                                setPickerRange(normalizeRange(newValue));
                              }}
                              onAccept={(
                                newValue: [Dayjs | null, Dayjs | null] | null
                              ) => {
                                if (!newValue) return;
                                const normalized = normalizeRange(newValue);

                                setPickerRange(normalized);
                                setDateRange(normalized);

                                if (normalized[0] && normalized[1]) {
                                  const updatedParams = new URLSearchParams(
                                    searchParams
                                  );
                                  updatedParams.set(
                                    "startDate",
                                    normalized[0].format("YYYY-MM-DD")
                                  );
                                  updatedParams.set(
                                    "endDate",
                                    normalized[1].format("YYYY-MM-DD")
                                  );
                                  setSearchParams(updatedParams);
                                }
                              }}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  color: "secondary",
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                    width: 250,
                                  },
                                  placeholder: "Select Date Range",
                                  InputLabelProps: { shrink: true },
                                  label: "Date Range",
                                  InputProps: {
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <CalendarMonthIcon
                                          fontSize="small"
                                          sx={{ cursor: "pointer" }}
                                        />
                                      </InputAdornment>
                                    ),
                                  },
                                },
                                actionBar: {
                                  actions: ["cancel", "accept"],
                                  sx: {
                                    "& .MuiButton-root": {
                                      color: "secondary.main",
                                      "&:hover": {
                                        backgroundColor: "#fbf7fc",
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>

                          {isSingleDayRange(dateRange) && (
                            <>
                              <Tooltip title="Previous Day">
                                <IconButton //previous date
                                  data-tracker="454"
                                  onClick={() =>
                                    handleDateRangeNavigation("prev")
                                  }
                                  //disabled={!isSingleDayRange(dateRange)}
                                  size="small"
                                >
                                  <ArrowLeftIcon sx={{ fontSize: 30 }} />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Next Day">
                                <IconButton //next date
                                  data-tracker="454"
                                  onClick={() =>
                                    handleDateRangeNavigation("next")
                                  }
                                  //   disabled={!isSingleDayRange(dateRange)}
                                  size="small"
                                >
                                  <ArrowRightIcon sx={{ fontSize: 30 }} />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </Stack>
                        <Stack
                          direction="row"
                          gap={1}
                          alignItems="flex-start"
                          flexWrap="wrap"
                        >
                          {siteLabels?.map((site: any) => {
                            return (
                              <Chip
                                key={site}
                                label={site}
                                sx={{
                                  bgcolor: "secondary.dark",
                                  color: "white",
                                  height: "26px",
                                }}
                              />
                            );
                          })}
                        </Stack>
                      </Stack>
                    </Stack>
                    <Typography variant="body2" color="text.secondary">
                      Here you will find a step by step breakdown of{" "}
                      {selectedActionType?.toLocaleUpperCase()}'s that were
                      loaded back into the ads platform.
                      <br /> At any point in the funnel, you'll be able to see
                      How many deposits were lost due to the specific reasoning,
                      in addition, you’ll get all deposit details at the player
                      level.
                    </Typography>
                  </Box>
                </Grid>
                {/* <Grid size={4}>
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-end"
                    sx={{ height: "100%" }}
                  >
                    <Stack direction={"row"} gap={1} alignContent={"center"}>
                      <FlagCircleOutlinedIcon
                        sx={{ color: "rgba(211, 47, 47, 1)" }}
                      />
                      <Typography variant="subtitle1">
                        Gaps that requires investigation: {GapCalculated}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid> */}
              </Grid>
            </>
          </Paper>
          <Divider sx={{ marginBlock: "10px" }} />
          <Paper sx={{ mb: 2 }}>
            {isSingle === false ? (
              <Stack>
                <ConversionsUploadOverTimeGraph data={loadedFromTotal} />
              </Stack>
            ) : null}
          </Paper>
          <Paper sx={{ mb: 2 }}>
            <Grid container spacing={2}>
              <Grid size={12}>
                <Stack direction={"column"} sx={{ padding: "16px" }}>
                  <Typography variant="h5" mb={1}>
                    Unloaded Conversions Breakdown
                  </Typography>
                  <Stack direction={"row"} gap={8} alignItems={"center"}>
                    {rows?.length > 0 ? (
                      <FtdLoadedPieChart
                        loadedPerc={Number(aggregatedPercLoaded.toFixed(2))}
                        loadedCount={totalConversionLoaded}
                        totalLoaded={totalConversion}
                        selectedActionType={selectedActionType?.toLocaleUpperCase()}
                      />
                    ) : (
                      <Alert
                        sx={{ color: "#ED6C02", mb: 1 }}
                        severity="warning"
                        icon={
                          <InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />
                        }
                      >
                        NO DATA
                      </Alert>
                    )}

                    {Object.values(updatedDataSegmentA)?.length > 0 ? (
                      <MultiSegmentBar
                        dataSegments={updatedDataSegmentA}
                        selectedType={selectedActionType?.toLocaleUpperCase()}
                      />
                    ) : (
                      ""
                    )}
                  </Stack>
                </Stack>
                <GapsinBrandData
                  rows={gapBrandData?.query_output}
                  total={totalConversion}
                />
                <UnpaidTrafficSource
                  rows={trafficSourceData?.query_output}
                  selecteDate={combinedDateRange}
                  total={totalConversion}
                />
                <MissingPlatformID
                  rows={platformIDdata?.query_output}
                  selecteDate={combinedDateRange}
                  total={totalConversion}
                />
                <ConversionLoadingFailures
                  rows={loadingFailuresData?.query_output}
                  selecteDate={combinedDateRange}
                  total={totalConversion}
                />
                {selectedActionType?.toLowerCase() === "ftd" ? (
                  <ConversionsUploadBreakdownIncvTraffic
                    rows={incentivizedTrafficData?.query_output}
                    selecteDate={combinedDateRange}
                    total={totalConversion}
                  />
                ) : null}
              </Grid>
            </Grid>
          </Paper>
          <Paper sx={{ mb: 2 }}>
            <Grid container spacing={2}>
              <Grid size={12}>
                {/* please change this part as i copied it from unloaded part as the design is same*/}
                <Stack direction={"column"} sx={{ padding: "16px" }}>
                  <Typography variant="h5" mb={1}>
                    Loaded Conversions Breakdown
                  </Typography>
                  <Stack direction={"row"} gap={8} alignItems={"center"}>
                    {rows?.length > 0 ? (
                      // Please make a new component for this
                      <FtdLoadedPieChartB
                        loadedCount={totalConversionLoaded}
                        totalConversion={totalConversion}
                        selectedActionType={selectedActionType}
                        altIdentifier={
                          platformIdentifiersData?.query_output?.length
                        }
                        late={lateConversionsData?.query_output?.length}
                      />
                    ) : (
                      <Alert
                        sx={{ color: "#ED6C02", mb: 1 }}
                        severity="warning"
                        icon={
                          <InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />
                        }
                      >
                        NO DATA
                      </Alert>
                    )}

                    {Object.values(updatedDataSegmentB)?.length > 0 ? (
                      <MultiSegmentBar
                        dataSegments={updatedDataSegmentB}
                        selectedType={selectedActionType?.toLocaleUpperCase()}
                      />
                    ) : (
                      ""
                    )}
                  </Stack>
                </Stack>
                <LateConversions
                  rows={lateConversionsData?.query_output}
                  selecteDate={combinedDateRange}
                  total={totalConversion}
                />
                <AlternativePlatformIdentifiers
                  rows={platformIdentifiersData?.query_output}
                  selecteDate={combinedDateRange}
                  total={totalConversion}
                />
              </Grid>
            </Grid>
          </Paper>
          <Paper sx={{ mt: 2 }}>
            <ConversionsUploadComparison
              uploadedToPlatformsData={uploadedToPlatformsData?.query_output}
              advertisingPlatformsData={advertisingPlatformsData?.query_output}
              selecteDate={combinedDateRange}
            />
          </Paper>
          {/* <DetailedPlayerLevel
          rows={loadingFailuresData?.query_output}
          total={rows[0]?.total_conversion}
        /> */}
        </>
      )}
    </>
  );
};

export default FtdLoadedFromTotal;
